module.exports = __webpack_public_path__ + "images/花筑村全景_06-1.jpg?v=59dbaf56";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu5/花筑村全景_06-1.jpg
 ** module id = 93
 ** module chunks = 1 2
 **/